import React from 'react'
import Home2 from './Pages/Home2'

const LandingPage = () => {
  return (
    <>
        
        <Home2/>

    </>
  )
}

export default LandingPage